import { useMemo } from 'react'

import { Control, useWatch } from 'react-hook-form'

import { ConfirmDialog } from 'components/common'
import {
  ReplaceBookingDriverDtoInput,
  useGetAvailableSubDriversQuery,
  useGetDriverByCurrentUserQuery,
} from 'generated/graphql'

interface IReplaceConfirmDialogProps {
  openConfirmModal: boolean
  setOpenConfirmModal: React.Dispatch<React.SetStateAction<boolean>>
  onConfirm: () => void
  allocatedDriverName: string
  control: Control<ReplaceBookingDriverDtoInput, any>
  bookingId: number
}

const ReplaceConfirmDialog = ({
  openConfirmModal,
  setOpenConfirmModal,
  onConfirm,
  allocatedDriverName,
  control,
  bookingId,
}: IReplaceConfirmDialogProps) => {
  const driverId = useWatch({
    control,
    name: 'driverId',
  })

  const { data: driverData } = useGetDriverByCurrentUserQuery()

  const { data: availableDriversData } = useGetAvailableSubDriversQuery({
    variables: {
      bookingId,
    },
    fetchPolicy: 'cache-only',
  })

  const selectedDriverName = useMemo(() => {
    const driver = availableDriversData?.availableSubDrivers.find((d) => d.id === driverId)
    if (!driver) return ''

    const isCurrentUser = driver.id === driverData?.driverByCurrentUser?.id
    return isCurrentUser ? 'You' : driver.name
  }, [driverId, availableDriversData?.availableSubDrivers, driverData?.driverByCurrentUser?.id])

  return (
    <ConfirmDialog
      closeAfterTransition={false}
      open={openConfirmModal}
      setOpen={setOpenConfirmModal}
      onConfirm={onConfirm}
      title={'Confirm'}
      message={`You chose to replace the allocated driver ${allocatedDriverName} with the selected ${selectedDriverName}`}
      option1='Discard'
      option2='Proceed'
    />
  )
}
export default ReplaceConfirmDialog
